import { ChangeDetectionStrategy, Component, HostBinding, input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'companyid-title-and-subtitle[title]',
    templateUrl: './title-and-subtitle.html',
    styleUrl: './title-and-subtitle.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleAndSubtitleComponent {
    public title = input.required<string>();
    public subtitle = input<string>('');

    @HostBinding('class')
    public readonly hostClassname = 'flex flex-col gap-y-15px text-large-regular text-primary-text-color';
}
